import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=10f98c48&scoped=true&"
import script from "./VersionModal.vue?vue&type=script&lang=js&"
export * from "./VersionModal.vue?vue&type=script&lang=js&"
import style0 from "./VersionModal.vue?vue&type=style&index=0&id=10f98c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f98c48",
  null
  
)

export default component.exports